export default "__VITE_ASSET__CzFZozPJ__"